import type { MiniGame } from './types';

/**
 * 所有作業小遊戲（id → 遊戲）。新增遊戲：寫 games/<id>.ts（export const game），content/minigames.json 加一筆，這裡會自動找到。
 * v1.4.1：小遊戲改成「用到才下載」（約 1 MB 的程式不用在開遊戲時就下載）；開機幾秒後會在背景先把它們抓下來，打開作業時就不用等。
 */
const MODULES = import.meta.glob<{ game: MiniGame }>('./games/*.ts');
const LOADERS: Record<string, () => Promise<{ game: MiniGame }>> = Object.fromEntries(
  Object.entries(MODULES).map(([path, load]) => [path.replace(/^.*\/([^/]+)\.ts$/, '$1'), load]),
);
const loaded = new Map<string, MiniGame>();

export const hasGame = (id: string): boolean => id in LOADERS;
export const gameIds = (): string[] => Object.keys(LOADERS);
/** 已經下載好的就直接給（同步），還沒有回傳 null */
export const gameNow = (id: string): MiniGame | null => loaded.get(id) ?? null;
export async function loadGame(id: string): Promise<MiniGame | null> {
  const hit = loaded.get(id); if (hit) return hit;
  const ld = LOADERS[id]; if (!ld) return null;
  const m = await ld();
  loaded.set(id, m.game); return m.game;
}
/** 背景預先下載全部小遊戲（不擋住畫面） */
export function preloadGames(): void {
  for (const id of Object.keys(LOADERS)) void loadGame(id).catch(() => { /* 網路斷了，等用到時再試 */ });
}
